module.exports = __webpack_public_path__ + "media/images/flags/16/Haiti-a47675b4177bc8ea56552ad9c3f4c191.png";